// Applies persisted display preferences (Settings → /me/preferences) to the
// document root so app-level CSS can honor them. The attributes set here are
// the single source of truth consumed by `:root[data-density='compact']` and
// `:root[data-motion='reduced']` rules in styles/app.css. Both toggles are
// contract-required to be demonstrably honored (rebuild contract D11 /
// AC-ME-4) — do not add keys here without a real CSS or behavior consumer.
export function applyDisplayPreferences(prefs) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const p = prefs && typeof prefs === 'object' ? prefs : {};
  if (p.compactDensity) root.setAttribute('data-density', 'compact');
  else root.removeAttribute('data-density');
  if (p.reduceMotion) root.setAttribute('data-motion', 'reduced');
  else root.removeAttribute('data-motion');
}
